import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharingService } from '../../../services/share.service';

@Component({
  selector: 'app-aboutandeventform',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './aboutandeventform.component.html',
  styleUrl: './aboutandeventform.component.scss'
})
export class AboutandeventformComponent {
  userForm!: FormGroup;
  submitAttempt: boolean = false;
  toasterTimeout = 3000;
  loader: boolean = false;
  states: any[] = [];

  constructor(private svc: SharingService, private toastrService: ToastrService, private formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$")])],//, Validators.pattern(this.emailPattern) 
      company: ['', Validators.required],
      title: ['', Validators.required],
      topic: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      zip: [''],
    })
    this.getCompanyStates();
  }


  getCompanyStates() {
    var url = 'ListUsaStatesData';
    this.svc.getData(url).subscribe((res: any) => {
      this.states = res.data;
    })
  }



  saveForm() {
    this.submitAttempt = true;
    if (this.userForm.valid) {
      var url = 'ApplicationForm';
      const fullName = this.userForm.value.name.trim();
      const nameParts = fullName.split(" ");

      let firstName = "";
      let lastName = "";

      if (nameParts.length === 1) {
        firstName = nameParts[0];
        lastName = "";
      } else {
        lastName = nameParts.pop()!; // get the last part
        firstName = nameParts.join(" "); // join the rest
      }
      let obj = {
        "firstname": firstName,
        "lastname": lastName,
        "email": this.userForm.value.email,
        "company": this.userForm.value.company,
        "title": this.userForm.value.title,
        "state": this.userForm.value.state,
        "city": this.userForm.value.city,
        "zip": this.userForm.value.zip,
        "topic": this.userForm.value.topic,
        "form_type": "eventUpdate",
        status: 1
      }
      this.loader = true;
      this.svc.postData(url, obj).subscribe((Object: any) => {
        this.loader = false;
        this.userForm.reset({
          state: '' // Set state dropdown to empty (default)
        });
        this.submitAttempt = false;
        this.toastrService.clear();
        this.toastrService.success(Object.message, '', {
          closeButton: true,
          timeOut: this.toasterTimeout
        });
      }, err => {
        this.loader = false;
        this.toastrService.clear();
        this.toastrService.error(err.error.message, '', {
          closeButton: true,
          timeOut: this.toasterTimeout
        });
      })
    }
  }

}
